import type { ReactElement, ReactNode } from 'react';
import { cn } from './cn';

interface Props {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: Props): ReactElement {
  return (
    <div
      className={cn('flex flex-col items-center justify-center gap-3 p-8 text-center', className)}
    >
      {icon && <div className="empty-icon">{icon}</div>}
      <h2 className="empty-title text-lg font-semibold">{title}</h2>
      {description && <p className="empty-desc max-w-md text-sm">{description}</p>}
      {action}
    </div>
  );
}
